import { HttpContext, HttpContextToken } from '@angular/common/http';

/** Marca una petición para que `SpinnerInterceptor` no levante el spinner global. */
export const PETICION_SIN_SPINNER = new HttpContextToken<boolean>(() => false);

/** Azúcar para `{ context: contextoSinSpinner() }` en los servicios. */
export const contextoSinSpinner = (): HttpContext =>
  new HttpContext().set(PETICION_SIN_SPINNER, true);
